import { render, staticRenderFns } from "./narcoticMedicationQuar.vue?vue&type=template&id=13589f06"
import script from "./narcoticMedicationQuar.vue?vue&type=script&lang=js"
export * from "./narcoticMedicationQuar.vue?vue&type=script&lang=js"
import style0 from "./narcoticMedicationQuar.vue?vue&type=style&index=0&id=13589f06&prod&lang=css"
import style1 from "./narcoticMedicationQuar.vue?vue&type=style&index=1&id=13589f06&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports